import Req from '@request'

function loginBase({
    dispatch,
    commit,
    params,
    state,
    rootState,
    url
}) {
    return new Promise(async (resolve, reject) => {
        Req.loadRequest(url, params).then(res => {
            commit('setToken', res.token)
            commit('setGuestId', res.id)
            localStorage.setItem('projectId', res.projectId)

            resolve(res)
        }).catch((res) => {
            reject(res)
        })
    })
}

export default {
    loginCode({
        dispatch,
        commit,
        state,
        rootState
    }, params) {
        return loginBase({
            dispatch,
            commit,
            params,
            state,
            rootState,
            url: 'login/loginCode',
        })
    },
    getUserInfo({
        commit
    }, params = {}) {
        const guestId = params.guestId || localStorage.getItem('guestId')
        return Req.loadRequest('common/guests', {
            guestId
        }).then(res => {
            sessionStorage.setItem('name', res.name)
            commit('setUserInfo', {
                phone: res.phone,
                name: res.name,
                cardNo: res.cardNo,
                area: res.area,
                company: res.company,
                cardType: res.cardType,
                department: res.department,
                job: res.job,
                sex: res.sex,
                appendState: res.appendState,
                profilePic: res.profilePic
            })
            return res
        })
    },
    logout({
        dispatch,
        commit,
        state,
        rootState
    }, params = { intercept: false }) {
        return new Promise((resolve, reject) => {
            commit('setUserInfo', {})
            commit('setToken', '')
            commit('setGuestId', '')
            localStorage.clear()
            sessionStorage.clear()
            localStorage.removeItem('projectCode')
            resolve()
        })
    },

}
